const selectors = {
  allAdsList: (state) => state.setting.allAdsList.data,
  changeConnectedAdsResult: (state) => state.setting.changeConnectedAdsResult.data,
};

export default selectors;
